import styled from 'styled-components';

import { media, getThemeColor, getThemeTransition } from '@utils/styled';

import LazyImg from '@common/components/LazyImg';
import Typography from '@common/components/Typography';
import { CarouselWrapper } from '@common/components/Carousel/Carousel.styled';
import { IconButton } from '@common/components/IconButton';

export const ImagesWrapperDesktop = styled.div`
  position: relative;
  display: none;
  grid-column: span 12;

  ${media.from880up`
    grid-column: span 7;
    display: block;
  `}

  ${media.from1200up`
    grid-column: span 8;
  `}
`;

export const ImagesContainerDesktop = styled.div`
  position: sticky;
  will-change: top;
  display: flex;
  flex-direction: column;
  transition: ${({ shouldAnimate }) =>
    shouldAnimate && getThemeTransition('top', 'fast')};
`;

export const ImagesWrapperMobile = styled.div`
  position: relative;
  grid-column: span 12;
  max-width: 100vw;

  ${media.from880up`
    display: none;
  `}

  .swiper {
    ${({ theme }) =>
      theme.getFluidSpacing(
        'margin-left',
        'widthBased',
        0,
        true,
        'safe-area-inset-left',
      )};
    ${({ theme }) =>
      theme.getFluidSpacing(
        'margin-right',
        'widthBased',
        0,
        true,
        'safe-area-inset-right',
      )};
  }

  img {
    width: 100%;
  }

  ${CarouselWrapper} {
    margin-bottom: 0;
  }
`;

export const HeroLazyImg = styled(LazyImg)`
  background-color: ${getThemeColor('bluegrey.95')};

  & img {
    display: block;
  }
`;

export const ZoomButton = styled.button.attrs({ type: 'button' })`
  position: relative;
  width: 100%;
  border: none;
  padding: 0;
  cursor: zoom-in;

  &:not(:last-of-type) {
    ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 5)};
  }
`;

export const Discount = styled(Typography).attrs({
  customAs: 'span',
  variant: 'subtitle2',
})`
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  padding: 0.5rem 1.5rem;
  background-color: ${getThemeColor('hue.green')};
  color: ${getThemeColor('grey.100')};
  ${({ withAdditionalSpacing }) =>
    withAdditionalSpacing && 'margin-bottom: 10rem;'};

  ${media.from880up`
    bottom: auto;
    top: 3rem;
    right: 3rem;
  `}
`;

export const FavoriteToggleButton = styled(IconButton)`
  position: absolute;
  top: 4.8rem;
  right: 2rem;
  display: flex;

  ${media.from640up`
    ${({ isExpiredOffer }) => (isExpiredOffer ? 'display: none' : 'display: flex')};
  `}

  ${media.from880up`
    display: none;
  `}
`;
